module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_2_M1-091f45ab3f0603a6f8df6942df8af300.webp";